import { userDestinationsActions, userDestinationsSelectors } from '@anm/store/modules/userDestinations';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const useDestinationsList = (canFetch = true) => {
  const dispatch = useDispatch();
  const list = useSelector(userDestinationsSelectors.selectEnabledDestinations);
  const error = useSelector(userDestinationsSelectors.selectDestinationsListError);
  const isPending = useSelector(userDestinationsSelectors.selectDestinationsListIsPending);

  useEffect(() => {
    if (!list && !isPending && !error && canFetch) {
      dispatch(userDestinationsActions.fetchDestinationsList({ query: '' }));
    }
  }, [list, isPending, error, canFetch]);

  return [isPending, list] as const;
};

export default useDestinationsList;
